module.exports = __webpack_public_path__ + "img/machine.05688c1b.jpg";